module.exports = __webpack_public_path__ + "static/media/service1.cce959eb.svg";